import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'antd';

// 自定義內聯樣式，徹底覆蓋 Dropzone 的預設樣式
const dropzoneStyle = {
  border: 'none',
  borderStyle: 'none',
  background: 'transparent',
  padding: 0,
  width: 'auto',
  outline: 'none'
};

const containerStyle = {
  border: 'none',
  background: 'transparent',
  padding: 0,
  margin: 0
};

class MyReactFiles extends Component {
  onDrop = (acceptedFiles, rejectedFiles) => {
    const { onFilesChange, onFilesError } = this.props;
    if (acceptedFiles.length > 0 && typeof onFilesChange === 'function') {
      onFilesChange(acceptedFiles);
    }
    if (rejectedFiles.length > 0 && typeof onFilesError === 'function') {
      onFilesError(rejectedFiles);
    }
  }

  render() {
    const { accept, disabled } = this.props;

    return (
      <div className="files" style={containerStyle}>
        <Dropzone
          accept={accept}
          multiple={false}
          maxSize={10000000} // 10MB
          onDrop={this.onDrop}
          style={dropzoneStyle}
          disablePreview={true}
          disabled={disabled}
        >
          <div className="files-dropzone" style={containerStyle}>
            <Button type="primary" disabled={disabled}>
              上傳照片
            </Button>
          </div>
        </Dropzone>
      </div>
    );
  }
}

export default MyReactFiles;



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/MyReactFiles.jsx